import { IconNames, IconQualitySizes, IconSizes } from 'atoms/Icon'

export const QUALITY_BADGE_ICON_HEIGHT = IconSizes.xMSm

export type QualityBadgeProps = {
  icon: IconNames
  iconSize: IconQualitySizes
}

/** Strip API noise (`_4K` → `4K`) so badge matching is stable. */
export function normalizeQualityToken(quality: string): string {
  return quality
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
}

export function qualityBadgeProps(quality: string): QualityBadgeProps | null {
  switch (normalizeQualityToken(quality)) {
    case '4K':
      return {
        icon: IconNames.qualityBadge4k,
        iconSize: IconQualitySizes.qualityBadge4k,
      }
    case '2K':
      return {
        icon: IconNames.qualityBadge2k,
        iconSize: IconQualitySizes.qualityBadge2k,
      }
    case 'SD':
      return {
        icon: IconNames.qualityBadgeSd,
        iconSize: IconQualitySizes.qualityBadgeSd,
      }
    case 'HD':
      return {
        icon: IconNames.qualityBadgeHd,
        iconSize: IconQualitySizes.qualityBadgeHd,
      }
    case 'FHD':
      return {
        icon: IconNames.qualityBadgeFhd,
        iconSize: IconQualitySizes.qualityBadgeFhd,
      }
    default:
      return null
  }
}

/** True when value is an API/display resolution token (never show as raw text). */
export function isQualityResolutionToken(value: unknown): value is string {
  return typeof value === 'string' && qualityBadgeProps(value) != null
}
